<template>
  <div>
    <schoolFilter ref="schoolFilterData" @getCustomerId = "get_subject_list"/>
    <vx-card title="Select View" class="mb-4">
      <vs-row>
        <vs-col vs-lg="11" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col class="p-1" vs-lg="3" vs-sm="12" vs-xs="12">
              <v-select class="w-full" :options="course_type" v-model="course_name_filter"  label="name" :reduce="(item) => item.value" placeholder="Course Type"></v-select>
            </vs-col>
            <vs-col class="p-1" vs-lg="4" vs-sm="12" vs-xs="12">
               <v-select
               v-model="course_class_type_filter"
                  class="w-full"
                  :options="course_class_type_list"
                  label="name"
                  :reduce="(item) => item.value"
                  placeholder="Select Class Type"
                />
            </vs-col>
            <vs-col class="p-1" vs-lg="4" vs-sm="12" vs-xs="12">
              <v-select class="w-full" v-model="course_Subject_type_filter"
                  :options="subject_list"
                  label="subject_name"
                   :clearable="false"
                          @open="onOpen"
                          @close="onClose"
                  :reduce="(option) => option.id" placeholder="Subject Name">
                   <template #list-footer>
                            <li ref="load" class="loader" v-show="subject_meta.has_next">
                              Loading more courses...
                            </li>
                          </template>
                          </v-select>
            </vs-col>
            
          </vs-row>
        </vs-col>
        <vs-col vs-lg="1" vs-sm="12" vs-xs="12">
          <div class="p-1 flex">
            <vs-button class="includeIcon includeIconOnly" @click="courseFilter">Go</vs-button>

            <vs-tooltip text="Reset">
              <vs-button type="border" icon-pack="feather" @click="resetFilter" icon="icon-refresh-ccw" class="ml-2"></vs-button>
            </vs-tooltip>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-card class="cstm_vx_card pb-4">
      <div class="flex justify-betwwen" slot="header">
        <h4>Courses</h4>
      </div>
      <div>
        <div class="flex justify-end items-center mb-4 course-selct-holder">
          <v-select
            class="mx-2"
            v-model="commonFilterSelected"
            :options="commonFilterOption"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :clearable="false"
            @input="getFilterCourse()"
          />

          <div class="flex items-center icon_holder ml-2">
 <vs-tooltip color="primary" position="top" text="Grid View">
                <span class="material-icons-outlined" :class="[grid ? 'active' : '']" @click="viewTab('grid')">grid_view</span>
              </vs-tooltip>
              <vs-tooltip color="primary" position="top" text="List View">
                <span class="material-icons-outlined" :class="[list ? 'active' : '']" @click="viewTab('list')">format_list_bulleted</span>
              </vs-tooltip>
          </div>
        </div>

    <div :class="[list ? 'list_view_holder' : 'grid_view_holder']" v-if="grid || list">
      <div class="each_card" v-for="(eachData, index) in courseList" :key="index" @click="goToCourseDetailsPage(eachData.id)">
        <div class="relative img_status">
          <img v-if="Object.keys(eachData.courseImage).length>0" :src="eachData.courseImage.file_path">
          <img v-else src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg" alt="course_image">
          <div class="course_status">
            <span class="material-icons-outlined">location_city</span>
            {{eachData.delivery_location_id != null?getDeliverylocation(eachData.delivery_location_id): ''}}
          </div>
        </div>
        <div class="content">
          <div class="inline-flex flex-wrap justify-between items-start w-full">
            <div class="w-3/4 mb-4">
              <h5>{{eachData.name}}</h5>            
              <p class="desc_para w-full">
                {{eachData.description || 'No Description'}}
              </p>
              <span class="more_holder" v-if="eachData.description !== null && activeMore != index " @click="showMore(index)">
                Read More
              </span>
              <span v-else class="inline-block" style="min-height: 16px;"></span>
              <span class="less_holder" v-if="activeMore == index" @click="showLess()">Show Less</span>
              <div class="more_content_holder" :class="[activeMore == index ? 'show' : '']">
                {{ eachData.description }}
              </div>
            </div>
          </div>
          <p>Subject: {{eachData.has_all_subject?'General':getDSubjects(eachData.subjects)}}</p>
          <p>Class Type:{{getCourseTypeName(eachData.course_class_type)}} </p>
          <div v-if="$route.path.includes('my-courses')">
            Course Progress:
          </div>
          <div class="inline-flex flex-wrap justify-between mt-4 w-full">
            <p class="money_holder">£{{eachData.total_price}}</p>
            <div class="flex items-center">
              <div class="cstm-img-holder" v-for="(tutor,index) in eachData.tutors" :key="index">
                <vs-tooltip :text="`${tutor.first_name} ${tutor.last_name}`" position="top" color="primary">
                  <img v-if="tutor.picture!=''" data-v-b18e1656="" :src="tutor.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                  <img v-else data-v-b18e1656="" src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                </vs-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
        
    </div>

        <pagination
          class="mb-8 pb-4"
          v-if="courseList.length !== 0"
          :meta="meta"
          @page-change="handlePageChange"
          style="float: right"
        />
      </div>
    </vs-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { getMyCourse, getSubjectList } from '@/api/course/courseapi'
import Pagination from '@/components/common/pagination'
import schoolFilter from '@/components/schoolFilter/schoolFilter'

export default {
  name: 'Courses',
  components: {
    Pagination,
    vSelect,
    schoolFilter
  },
  data () {
    return {
      locations: [
        {
          id: 1,
          name: 'At School'
        },
        {
          id: 2,
          name: 'Online'
        },
        {
          id: 3,
          name: 'At Home'
        },
        {
          id: 4,
          name: 'Other'
        }
      ],
      activeMore: null,
      grid: true,
      list: false,
      observer: new IntersectionObserver(this.loadMoreSubject),
      subject_list:[],
      course_name_filter:'',
      course_class_type_filter:'',
      course_Subject_type_filter:'',
      course_type:[
        {
          value: 1,
          name: 'Open'
        },
        {
          value: 2,
          name: 'Free'
        },
        {
          value: 3,
          name: 'Paid'
        },
        {
          value: 4,
          name: 'Recurring'
        }
      ],
      course_class_type_list:[
        {
          value:'self_based',
          name:'Self Paced Course'
        },
        {
          value:'online_one_2_one',
          name:'Online Individual Course'
        },
        {
          value:'online_one_2_many',
          name:'Online Group Course'
        },
        {
          value:'offline_one_2_one',
          name:'In Person Individual Course'
        },
        {
          value:'offline_one_2_many',
          name:'In Person Group Course'
        }
      ],
      search: '',
      courseList: [],
      default_course_image: '',

      filterBy: null,
      //pagination
      subject_meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1
      },

      //pagination

      commonFilterOption: [
        { id: 'All', label: 'All' },

        { id: 1, label: 'Alphabetical (A-Z)' },
        { id: 2, label: 'Alphabetical (Z-A)' }
      ],
      commonFilterSelected: {},
      options2: [
        { id: 1, label: 'All Instructors' },
        { id: 2, label: 'Instructor 1' }
      ],
      selected2: { id: 1, label: 'All Instructors' },
      gridView: true,
      listView: false,
      isGrid: true,
      isList: false
    }
  },

  methods: {
    goToCourseDetailsPage (id) {
      this.$router
        .push({
          name: 'CourseDetailsMyCourses',
          params: {
            customerId:this.$refs.schoolFilterData.$data.schoolId === null ? localStorage.getItem('customer_id') : this.$refs.schoolFilterData.$data.schoolId,
            course_id:id
          }
        })
        .catch(() => {})
     
                
    },
    getDSubjects (subjects) {
      const subjects_array = subjects.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      return subjects_array.join(', ')
    },
    showMore (index) {
      this.activeMore = index
    },
    showLess () {
      this.activeMore = null
    },
    getDeliverylocation (delivery_location_id) {
      const delivery_location = this.locations.filter(element => element.id === delivery_location_id)
      return delivery_location[0].name
    },
    viewTab (type) {
      if (type === 'grid') {
        this.grid = true
        this.list = false
      } else if (type === 'list') {
        this.grid = false
        this.list = true
      }      
    },
    async get_subject_list (customerId) {
      this.fetchCourseLists()
      const data = await getSubjectList(customerId)
      this.subject_list = data.data.data.subjectlist
      this.subject_meta = data.data.data.meta
    },
    async loadMoreSubject ([{isIntersecting, target}]) {


      const customer_id = (this.$refs.schoolFilterData.$data.schoolId === null) ? localStorage.getItem('customer_id') : this.$refs.schoolFilterData.$data.schoolId 

      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await getSubjectList(customer_id, this.subject_meta.current_page + 1)
          this.subject_list.push(...response.data.data.subjectlist)


          this.subject_meta = response.data.data.meta
        } catch (e) {}


        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpen () {
      if (this.subject_meta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    resetFilter () {
      this.course_name_filter = ''
      this.course_class_type_filter = ''
      this.course_Subject_type_filter = ''
      this.$refs.schoolFilterData.$data.schoolId = null
      this.fetchCourseLists()
    },
    courseFilter () {
      this.fetchCourseLists()
    },
    getCourseLabel (coursetype) {
      const index = this.course_class_type_list.findIndex((ele) => {
        return ele.value === coursetype
      })
      console.log(index)

      if (index >= 0) {
        return this.course_class_type_list[index].name
      }

      return coursetype
    },
    handlePageChange (page) {
      // console.log(page)
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = 10
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/my-courses/learning', query: queryPayload })
        .catch(() => {}).then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      this.fetchCourseLists(this.filterBy)
      // this.fetchSubjectList()
    },
    getCourseTypeName (typeId) {
      let courseTypeName = ''
      switch (typeId) {
      case 1:
        courseTypeName = 'Open'
        break
      case 2:
        courseTypeName = 'Free'
        break
      case 3:
        courseTypeName = 'Paid'
        break
      case 4:
        courseTypeName = 'Recurring'
        break
      default:
        courseTypeName = 'Others'
      }
      return courseTypeName
    },
    gridAction () {
      this.gridView = true
      this.listView = false
      this.isGrid = true
      this.isList = false
    },
    listAction () {
      this.gridView = false
      this.listView = true
      this.isGrid = false
      this.isList = true
    },
    async fetchCourseLists (filterId = null) {
      try {
        this.$vs.loading({
          text: 'Fetching Course List'
        })
        const queryParams = this.$route.query || {}
        this.query_page.page = queryParams.page || 1
        //filter
        const customer_id = this.$refs.schoolFilterData.$data.schoolId === null ? localStorage.getItem('customer_id') : this.$refs.schoolFilterData.$data.schoolId 
        const payload = {
          order_by_name: filterId,
          course_type_id:this.course_name_filter,
          subject_ids: this.course_Subject_type_filter ? [this.course_Subject_type_filter] : [],
          course_type: this.course_class_type_filter ? [this.course_class_type_filter] : [],
          customer_id,
          status:1
        }

        console.log(this.$route.path.includes('my-courses'))
      
        const responseClient = await getMyCourse(
          customer_id,
          this.query_page.page,
          localStorage.getItem('userId'),
          payload,
          
        )
        this.courseList = responseClient.data.data.course
        const data = await getSubjectList(customer_id)
        this.subject_list = data.data.data.subjectlist
        this.subject_meta = data.data.data.meta
        console.log(responseClient)
        this.default_course_image =
          responseClient.data.data.default_course_image
        this.meta = responseClient.data.data.meta
      } catch (error) {
        console.log(error)
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    getFilterCourse () {
      if (this.commonFilterSelected.id === 1) {
        this.fetchCourseLists('asc')
        this.filterBy = 'asc'
      } else if (this.commonFilterSelected.id === 2) {
        this.fetchCourseLists('desc')
        this.filterBy = 'desc'
      } else {
        this.fetchCourseLists(null)
        this.filterBy = null
      }
    }
  },
  mounted () {
    this.fetchCourseLists()
  },
  created () {
    //this.checkingQuery('/courses')
    this.commonFilterSelected = this.commonFilterOption[0]
  }
}
</script>

<style>
.cimage {
  height: 230px;
  width: 100%;
  object-fit: cover;
}
.table-img {
  height: 120px;
  width: 150px;
}
.course-selct-holder .v-select {
  min-width: 156px;
}
.view_holder {
  display: inline-flex;
  border: 1px solid #ccc;
  padding: 1px;
  border-radius: 5px;
}
.view_holder .vs-button.active {
  background-color: #41cfdd !important;
  color: #fff !important;
}
.course-card {
  position: relative;
  overflow: hidden;
  /* min-height: 346px; */
}
.course-card .course-label {
  position: absolute;
  left: -10px;
  top: 10px;
  background-color: #ff9f43;
  color: #fff;
  padding: 5px 15px;
  border-radius: 10px;
}
.course-card .course-img {
  height: 150px;
  object-fit: cover;
  object-position: top;
}
.course-heading {
  height: 37px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.course-table .table-img {
  width: 150px;
  border-radius: 8px;
  object-fit: cover;
}

@media (max-width: 767px) {
  .course-card .course-img {
    height: auto;
  }
}

@media (min-width: 1920px) {
  .course-card .course-img {
    height: 360px;
  }
}
</style>
<style scoped>

  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
